var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectEmailStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6339 0.871179C23.5677 0.332091 24.7181 0.332092 25.6518 0.87118L43.5423 11.2002C44.476 11.7393 45.0512 12.7356 45.0512 13.8138V34.4719C45.0512 35.5501 44.476 36.5464 43.5423 37.0855L25.6518 47.4145C24.7181 47.9536 23.5677 47.9536 22.6339 47.4145L4.74346 37.0855C3.80973 36.5464 3.23453 35.5501 3.23453 34.4719V13.8138C3.23453 12.7356 3.80973 11.7393 4.74346 11.2002L22.6339 0.871179Z",
    fill: "url(#paint0_linear_8467_89201)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32H17C16.4696 32 15.9609 31.7893 15.5858 31.4142C15.2107 31.0391 15 30.5304 15 30V20C15 19.4696 15.2107 18.9609 15.5858 18.5858C15.9609 18.2107 16.4696 18 17 18H31C31.5304 18 32.0391 18.2107 32.4142 18.5858C32.7893 18.9609 33 19.4696 33 20V26",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20L24 26L33 20M27 32L29 34L33 30",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8467_89201",
    x1: 25.35,
    y1: 7.95062e-7,
    x2: 3.01786,
    y2: 36.2143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51DA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AA646"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectEmailStep3);
export default __webpack_public_path__ + "static/media/ConnectEmailStep3.3432b162f28abb5a3f2156fc56d8bf74.svg";
export { ForwardRef as ReactComponent };